import React from 'react';

function PrintSchedulePopup({ datas, apptDate }) {
  return (
    <>
      <html>
        <body style={{ height: 'auto' }}>
          <table
            width="734px"
            cellSpacing="0"
            cellPadding="0"
            border="0"
            align="center"
            style={{
              paddingBottom: '10px',
            }}
          >
            <tbody>
              <tr width="734px">
                <td align="top" width="400px">
                  <span className="bold red" style={{ color: 'red' }}>
                    Appointments: {apptDate.appointmentDate}
                  </span>
                </td>
                <td align="top" width="286px">
                  <span className="bold" style={{ color: 'red' }}>
                    Provider: {apptDate.doctorName}
                  </span>
                </td>
                <td align="top" style={{ width: '24px' }}>
                  <span
                    className="bold"
                    style={{ color: 'red', width: '30px' }}
                  >
                    Location: {apptDate.locationName}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <div className="">
            <div
              className="left width100 one-edge-shadow clear-bottom"
              style={{ fontSize: '12px' }}
            >
              <table
                width="734px"
                cellSpacing="0"
                cellPadding="0"
                border="1"
                align="center"
                className="unselectable"
                style={{ backgroundColor: '#ffffff', marginTop: '10px' }}
              >
                <thead>
                  <tr
                    width="734px"
                    className="clinical-summry-pdf-grid-header-new-pdf brf-apnt-rpt"
                    style={{ backgroundColor: '#e7e7e7' }}
                  >
                    <th
                      width="67px"
                      align="left"
                      className="header-label-new-pdf Vital-sign-head-padding"
                      style={{
                        paddingTop: '10px',
                        paddingBottom: '10px',
                        fontWeight: 'bold',
                        borderLeft: '1px solid #d0d0d0',
                        textAlign: 'center',
                      }}
                    >
                      Reminder
                    </th>
                    <th
                      width="90px"
                      align="left"
                      className="header-label-new-pdf hdr-sec-brdr-new-pdf Vital-sign-head-padding"
                      style={{
                        paddingTop: '10px',
                        paddingBottom: '10px',
                        fontWeight: 'bold',
                        textAlign: 'center',
                      }}
                    >
                      Pt. Name
                    </th>
                    <th
                      width="110px"
                      align="left"
                      className="header-label-new-pdf hdr-sec-brdr-new-pdf Vital-sign-head-padding"
                      style={{
                        paddingTop: '10px',
                        paddingBottom: '10px',
                        fontWeight: 'bold',
                        textAlign: 'center',
                      }}
                    >
                      Contact#
                    </th>
                    <th
                      width="74px"
                      align="left"
                      className="header-label-new-pdf Vital-sign-head-padding"
                      style={{
                        paddingTop: '10px',
                        paddingBottom: '10px',
                        fontWeight: 'bold',
                        textAlign: 'center',
                      }}
                    >
                      Time
                    </th>
                    <th
                      width="83px"
                      align="left"
                      className="header-label-new-pdf hdr-sec-brdr-new-pdf Vital-sign-head-padding"
                      style={{
                        paddingTop: '10px',
                        paddingBottom: '10px',
                        fontWeight: 'bold',
                        textAlign: 'center',
                      }}
                    >
                      TOV
                    </th>
                    <th
                      width="74px"
                      align="left"
                      className="header-label-new-pdf hdr-sec-brdr-new-pdf Vital-sign-head-padding"
                      style={{
                        paddingTop: '10px',
                        paddingBottom: '10px',
                        fontWeight: 'bold',
                        textAlign: 'center',
                      }}
                    >
                      Provider
                    </th>
                    <th
                      width="90px"
                      align="left"
                      className="header-label-new-pdf hdr-sec-brdr-new-pdf Vital-sign-head-padding"
                      style={{
                        paddingTop: '10px',
                        paddingBottom: '10px',
                        fontWeight: 'bold',
                        textAlign: 'center',
                      }}
                    >
                      Payer
                    </th>
                    <th
                      width="83px"
                      align="left"
                      className="header-label-new-pdf hdr-sec-brdr-new-pdf Vital-sign-head-padding"
                      style={{
                        paddingTop: '10px',
                        paddingBottom: '10px',
                        fontWeight: 'bold',
                        textAlign: 'center',
                      }}
                    >
                      Status
                    </th>
                  </tr>
                </thead>

                <tbody className="unselectable">
                  {datas && datas.length > 0 ? (
                    datas.map((ele, index) => {
                      return (
                        <tr
                          width="734px"
                          className="pres-pdf-grid-body-new-pdf brf-apnt-rpt"
                          style={{ backgroundColor: '#f7fbf3' }}
                          key={index}
                        >
                          <td
                            align="top"
                            width="67px"
                            className="clinical-summry-name-new-pdf appntmnt-grid-padding-padd-nw border-lt"
                          >
                            <span className="pres-demographic-heading-new-pdf color000">
                              {ele.reminderStatus.reminderStTitle}
                            </span>
                          </td>
                          <td
                            align="top"
                            width="90px"
                            className="clinical-summry-date-new-pdf appntmnt-grid-padding-padd-nw"
                          >
                            <span className="pres-demographic-heading-new-pdf color000">
                              {ele.patient_name}
                            </span>
                          </td>
                          <td
                            align="top"
                            width="110px"
                            className="clinical-summry-date-new-pdf appntmnt-grid-padding-padd-nw"
                          >
                            <span className="pres-demographic-heading-new-pdf color000">
                              {ele.mobile}
                              <br />
                            </span>
                          </td>
                          <td
                            align="top"
                            width="74px"
                            className="clinical-summry-name-new-pdf appntmnt-grid-padding-padd-nw"
                          >
                            <span className="pres-demographic-heading-new-pdf color000">
                              {ele.visit_date}
                              {ele.startTime}
                              |
                              <br />
                              {ele.app_time}
                            </span>
                          </td>
                          <td
                            align="top"
                            width="83px"
                            className="clinical-summry-date-new-pdf appntmnt-grid-padding-padd-nw"
                          >
                            <span className="pres-demographic-heading-new-pdf color000">
                              &#9990; {ele.visit_type}
                              <br />
                              {ele.appt_new_slot} min.
                            </span>
                          </td>
                          <td
                            align="top"
                            width="74px"
                            className="clinical-summry-date-new-pdf appntmnt-grid-padding-padd-nw"
                          >
                            <span className="pres-demographic-heading-new-pdf color000">
                              {ele.providerFullName}
                            </span>
                          </td>
                          <td
                            align="top"
                            width="90px"
                            className="clinical-summry-date-new-pdf appntmnt-grid-padding-padd-nw"
                          >
                            <span className="pres-demographic-heading-new-pdf color000">
                              {ele.insurance_company_name}
                            </span>
                          </td>
                          <td
                            align="top"
                            width="83px"
                            className="clinical-summry-date-new-pdf appntmnt-grid-padding-padd-nw"
                          >
                            <span className="pres-demographic-heading-new-pdf color000">
                              {ele.currentStatus.showCurrentStatusOnButton}
                            </span>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr
                      width="734px"
                      className="pres-pdf-grid-body-new-pdf brf-apnt-rpt"
                      style={{ backgroundColor: '#f7refbf3' }}
                    >
                      <td colSpan="8" align="center">
                        <p>No data to display.</p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </body>
      </html>
    </>
  );
}
export default PrintSchedulePopup;
